<template>
  <div class="detail">
    <div class="play" id="live"></div>
    <div class="detail-box" :style="{ height: isAndroid ? 'calc(100vh - 9 / 16 * 100vw - 50px)' : `calc(100vh - 9 / 16 * 100vw - ${ 50 + safeHeight }px)`, 'padding-bottom': isAndroid ? 0 : '150px' }">
      <h3 class="padding">{{title}}</h3>
      <div class="padding header">
        <span class="desc">{{details}}</span>
        <div class="moreBox">
          <span class="more" @click="goIntroduction">查看更多</span>
          <span class="gradient"></span>
          <img class="right" src="../../../assets/images/right.svg" alt="">
        </div>
      </div>
      <span class="padding info">共{{getSubsectionCount}}小节  |  {{students}}人加入学习</span>

      <div class="play-box">
        <template v-for="(item, index1) of chapters" >
          <div v-for="(subsection, index) of item.subsections" @click="changeSubsectionStatus(index1, subsection, index)" :key="subsection.id" :class="{'play-box-item': true, active: Object.is(subsection.status, 1), played:  Object.is(subsection.status, 2)}">
            <img src="../../../assets/images/play.svg"/>
            <span class="content">{{subsection.title}}</span>
            <span class="time">{{subsection.time}}</span>
          </div>
        </template>
      </div>

      <div v-if="thought" class="padding think">
        <h2>思考一下</h2>
        <span>{{thought}}</span>
      </div>
      <template>
        <div class="padding message-header">
          <span>留言讨论</span>
          <!-- <button @click="goCreateRefining">
            <img src="../../../assets/images/edit.svg"/>
            写下想法</button> -->
        </div>
        <div class="message-box">
          <!-- <Message v-for="item of messages" :key="item.id" v-bind="item" /> -->
          <DynamicItem @deleteMessage="deleteMessage"  @updateItem="(reload) => updateItem(item, reload)" v-for="item of messages" :key="item.id" v-bind="item" />
        </div>
      </template>
    </div>
    <div class="footer" :style="{ height: isAndroid ? '50px' : `${ safeHeight + 50 }px` }">
        <button class="button" @click="goHome"><img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home1.svg"/>首页</button>
        <button @click="collection">
          <img v-if="isStore" src="../../../assets/images/black-collection.svg"/>
          <img v-else src="../../../assets/images/white-collection.svg"/>收藏</button>
        <button class="write-message" @click="goCreateRefining"><img src="../../../assets/images/editBlock.svg"/>写下想法</button>
      </div>
  </div>
</template>
<script>
import Aliplayer from 'Aliplayer'
import { isAndroid } from '../../../utils/utils'
import { safeHeight } from '../../../utils/config'
import { get, put, post } from '../../../utils/request'
import Mixins from '../../../minixs/ddMixis'
import { get as getUser } from '../../../utils/token'
import DynamicItem from '../../../components/DynamicItem'
import { goHomePath } from '../../../utils/power'
let player = null
export default {
  mixins: [Mixins],
  components: {
    DynamicItem
  },
  created () {
    this.getAllMessage()
    this.getRefiningDetails()
  },
  watch: {
    $route () {
      this.getAllMessage()
      this.getRefiningDetails()
    }
  },
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: safeHeight,
      chapters: [],
      cover: '',
      details: '',
      id: '',
      isStore: false,
      is_recommend: '',
      shareTitle: '',
      students: '',
      teacher: {},
      title: '',
      subtitle: '',
      type: '',
      thought: '',
      messages: [],
      subsection: null,
      subsectionIndex: 0,
      chapterIndex: 0
    }
  },
  methods: {
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    goIntroduction () {
      this.$router.push(`/exerland/introduction?id=${this.id}`)
    },
    deleteMessage (id) {
      let index = 0
      this.dynamic.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.dynamic.splice(index, 1)
    },
    goCreateRefining (circleId) {
      this.$router.push(`/exerland/create?curriculumId=${this.$route.params.id}`)
    },
    collection () {
      const user = getUser('user')
      const promise = post({
        url: '/user/store',
        data: {
          userId: user.id,
          curriculumId: this.id,
          isAdd: !this.isStore
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.isStore = !this.isStore
        }
      })
    },
    getAllMessage () {
      // if (!(this.getMessageAuth && this.getMessageAuth.message)) return
      const user = getUser('user')
      const promise = get({
        url: `/course/getComment/${this.$route.params.id}/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail: { data } } } = res
        if (Object.is(code, 200)) {
          this.messages = data
        }
      })
    },
    changeSubsectionStatus (index1, subsection1, index) {
      const user = getUser('user')
      subsection1.status = 1
      const subsection2 = Object.assign({}, subsection1, { status: 1, userId: user.id })
      const subsection = Object.assign({}, this.subsection, { status: 2, userId: user.id })
      this.chapters[this.chapterIndex].subsections.splice(this.subsectionIndex, 1, subsection)
      this.subsectionIndex = index
      this.chapterIndex = index1
      this.subsection = subsection2
      const promise = put({
        url: '/course/UpdateSubsectionStatus',
        data: {
          list: [subsection2, subsection]
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          // this.initPlay()
          this.switchPlay()
        }
      })
    },
    addRefiningRecode () {
      const { subsection } = this
      const user = getUser('user')
      const promise = post({
        url: '/course/createHistory',
        data: {
          curriculumId: this.$route.params.id,
          userId: user.id,
          title: subsection.title,
          subsectionId: subsection.id,
          chapterId: this.chapters[this.chapterIndex].id,
          time: subsection.time
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
        }
      })
    },
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    },
    getRefiningDetails () {
      const user = getUser('user')
      const promise = get({
        url: `/course/curriculumDetail/${this.$route.params.id}/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
          const { chapters } = detail
          chapters.forEach((item, index1) => {
            item.subsections.forEach((subsection, index) => {
              if (Object.is(subsection.status, 1)) {
                this.subsection = subsection
                this.chapterIndex = index1
                this.subsectionIndex = index
              }
            })
          })
          if (!this.subsection) {
            let subsection = null
            try {
              subsection = chapters[0].subsections[0]
              this.chapterIndex = 0
              this.subsectionIndex = 0
              /* eslint-disable-next-line */
            } catch (err) {
            }
            this.subsection = subsection
          }
          this.initPlay()
        }
      })
    },
    authAliyunPlayer () {
      return get({
        url: `/course/playAuth/${this.subsection.FileId}`
      })
    },
    /*
     * 销毁
    */
    distoryPlayer () {
      if (player) {
        player.dispose() // 销毁
        // $('#live').empty()// id为html里指定的播放器的容器id
        document.getElementById('live').innerHTML = ''
      }
      player = null
    },
    async switchPlay () {
      const auth = await this.authAliyunPlayer()
      const { data: { detail: { PlayAuth } } } = auth
      player.replayByVidAndPlayAuth(this.subsection.FileId, PlayAuth)
    },
    async initPlay () {
      this.distoryPlayer()
      if (!this.subsection) {
        return
      }
      const auth = await this.authAliyunPlayer()
      const { data: { detail: { PlayAuth } } } = auth
      const { subsection: { CoverUrl, FileId } } = this
      player = new Aliplayer({
        id: 'live',
        width: '100%',
        // autoplay: true,
        // encryptType: 1, // 当播放私有加密流时需要设置。
        vid: FileId,
        playauth: PlayAuth,
        // skinLayout: false,
        isLive: false, // 直播
        cover: CoverUrl,
        // source: media,
        // useH5Prism: true,
        height: `${window.innerWidth * 9 / 16}px`
        // liveStartTime: '2020/04/10 18:57:00',
        // liveOverTime: '2020/04/10 20:00:00'
      })
      player.on('ready', () => {
        /* eslint-disable-next-line */
        console.log('准备好')
        this.addRefiningRecode()
      })
      player.on('play', () => {
        /* eslint-disable-next-line */
        console.log('触发播放')
        // _this.labelTip = '课程未开始请留意时间，如需咨询 请联系客服微信：focuth01'
      })
      player.on('error', () => {
        /* eslint-disable-next-line */
        console.log('错误触发')
      })
      player.on('requestFullScreen', () => {
        /* eslint-disable-next-line */
        console.log('触发全屏事件')
      })
      player.on('cancelFullScreen', () => {
        /* eslint-disable-next-line */
        console.log('触发取消全屏事件')
      })
      player.on('ended', () => {
        /* eslint-disable-next-line */
        console.log('结束触发')
      })
    }
  },
  computed: {
    getSubsectionCount () {
      const { chapters } = this
      let count = 0
      chapters.forEach(item => {
        item.subsections.forEach(subsection => {
          ++count
        })
      })
      return count
    },
    getMessageAuth () {
      return this.$store.getters['refiningAuth/getAuth']
    }
  }
  // watch: {
  //   $route: 'fetchData'
  // }
}
</script>
<style lang="scss" scoped>
.padding {
  width: 87.2vw;
  margin: 0 auto;
}
// /deep/ html, body {
//   width:100%;
//   height:100%;
//   box-sizing: border-box;
//   overflow: hidden;
// }
.detail {
  position: relative;
  overflow: hidden;
  #live {
    width: 100%;
    height: calc(100vw * 9 / 16);
  }
  .detail-box {
    -webkit-overflow-scrolling: touch;
    overflow: scroll;
    box-sizing: border-box;
    h3 {
      font-size:20px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight: bold;
      color:rgba(51,51,51,1);
      line-height:24px;
      letter-spacing: 0.38px;
      margin-top: 12px;
      margin-bottom: 20px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      height: 16px;
      line-height: 16px;
      padding-bottom: 17px;
      border-bottom: 2px solid #f5f5f5;
      .desc {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:16px;
      }
      .moreBox {
        display: flex;
        align-items: center;
        position: relative;
        .more{
          font-size:12px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(136,136,136,1);
          margin-right: 7px;
          white-space: nowrap;
        }
        .gradient {
          position: absolute;
          bottom: 0;
          right: 70px;
          height: 100%;
          width: 40px;
          background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
        }
        .right {
          height: 12px;
        }
      }
    }
    .info {
      display: block;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:12px;
      padding: 11px 0;
    }
    .play-box {
      margin-top: 24px;
      .play-box-item {
        display: flex;
        justify-content:space-between;
        align-items: center;
        padding: 20px 24px 20px 16px;
        background:#fff;
        // border-bottom: 1px solid rgba(242,242,247,1);
        position: relative;
        &::after {
          position: absolute;
          left: 6.4%;
          bottom: 0;
          width: 87.2%;
          height: 1px;
          content: '';
          background: #F2F2F7;
        }
        img {
          height:12px;
          background:rgba(242,242,247,1);
          border-radius:4px;
          display: block;
          padding: 6px;
        }
        .content {
          font-size:15px;
          font-family:SFProText-Semibold,SFProText;
          font-weight:600;
          color:rgba(51,51,51,1);
          line-height:20px;
          width: 61.6vw;
          text-align: left;
        }
        .time {
          font-size:13px;
          font-family:SFProText-Regular,SFProText;
          font-weight:400;
          color:rgba(60,60,67,0.6);
          line-height:18px;
        }
      }
      .active {
        position: relative;
        background:rgba(245,245,245,1);
        &::after {
          position: absolute;
          left: 0;
          top: 0;
          width: 8px;
          height: 100%;
          content: '';
          background: #18CC9F;
        }
      }
      .played {
        opacity: 0.5;
      }
    }
    .think {
      margin-top: 36px;
      h2 {
        font-size:18px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:20px;
      }
      span {
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:24px;
        background:rgba(245,245,245,1);
        border-radius:9px;
        padding: 20px 24px;
        display: block;
        margin-top: 24px;
      }
    }
    .message-header {
      margin-top: 32px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size:18px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:20px;
      }
      button {
        width:128px;
        height:40px;
        background:rgba(24,204,159,1);
        box-shadow:0px 4px 12px 0px rgba(0,0,0,0.08);
        border-radius:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:16px;
        text-shadow:0px 4px 12px rgba(0,0,0,0.08);
        border: none;
        box-sizing: border-box;
        img {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 16px;
        }
      }
    }
    .message-box {
      margin-top: 15px;
    }
  }
  .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      // height: 50px;
      box-sizing: border-box;
      padding: 5px 6.4vw;
      background: #fff;
      box-shadow:0px -2px 8px 0px rgba(0,0,0,0.04);
      display: flex;
      justify-content: space-between;
      button {
        border: none;
        // width: 41.6vw;
        background: #fff;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        display: flex;
        align-items: center;
        // height: 40px;
        // background-color: red;
        img {
          width:18px;
          margin-right: 4px;
        }
      }
      .write-message {
        width:146px;
        // height:40px;
        padding: 8px 24px;
        background:rgba(24,204,159,1);
        border-radius:20px;
        box-sizing: border-box;
        font-size:17px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(255,255,255,1);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
}
button {
  outline: none;
  webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
